import { useQuery, UseQueryOptions } from 'react-query';
import { APIError } from '~/src/utils/error';
import { useCurrentOrgFprint } from '~/src/entities/user';
import { composeQueryOpts } from '~/src/entities/utils';
import { keys } from '../keys';
import templatesService from '~/src/services/api/templatesService';

export const useCheckClioTemplatesExist = (
  options: UseQueryOptions<boolean, APIError> = {},
) => {
  const orgFprint = useCurrentOrgFprint();

  return useQuery(
    composeQueryOpts(options, {
      queryKey: keys.clioTemplatesExist(),
      queryFn: async () => {
        const templates = await templatesService.getTemplates(orgFprint, {
          page: 1,
          search: undefined,
          sortBy: undefined,
          order: undefined,
          limit: 1,
          clioTemplates: 'only',
          practiceArea: undefined,
          jurisdiction: undefined,
        });
        return templates.length > 0;
      },
    }),
  );
};
